import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { Footer, Navbar } from "../adminComponents";
import axios from "axios";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";

const AddUser = () => {

  const [inputData,setInputData]=useState({email:'',passcode:'',userName:'',confirmPasscode:''});
  const navigate=useNavigate();
  const [userList,setUserList]=useState([])
  const branchId = localStorage.getItem("eshopBranchID");

  const getUserList = async () => {
        const response=await axios.get(configData.SERVER_ADMIN_URL+`/userList/${branchId}`)
        console.log(response.data);
          setUserList(response.data);
        };

  useEffect(() => {
        getUserList();
    }, []); 

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});    
  }

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!inputData.userName || !inputData.email || !inputData.passcode || !inputData.confirmPasscode) {
    alert("All fields are required");
    return;
  }

  if (inputData.passcode !== inputData.confirmPasscode) {
    alert("Password not matches");
    return;
  }

  if (inputData.passcode.length < 6) {
    alert("Password must be at least 6 characters");
    return;
  }

  try {
    const res = await axios.post(configData.SERVER_ADMIN_URL + '/UserEntry',
        {email: inputData.email, passcode: inputData.passcode, userName: inputData.userName,branchId:branchId});

    alert(res.data.message || (res.data.success ? "User created successfully" : "User already exists"));
    getUserList();

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">User Entry</h1>
        <hr />
        <div class="card card-body my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>

                <div class="my-3">
                <label for="display-4">User Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="userName"
                  name="userName"
                  value={inputData.userName}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>

              <div class="my-3">
                <label for="display-4">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email"
                  placeholder="name@example.com"
                  value={inputData.email}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>

              <div class="my-3">
                <label for="floatingPassword display-4">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="passcode"
                  name="passcode"
                  placeholder="Password"
                  value={inputData.passcode}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>

              <div class="my-3">
                <label for="floatingPassword display-4">Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="confirmPasscode"
                  name="confirmPasscode"
                  placeholder="Password"
                  value={inputData.confirmPasscode}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>

              <div className="my-3 text-center">
                <button class="my-2 mx-auto btn btn-info" type="submit">
                  POST
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="card">
            <div className="card-header">User List</div>
            <div className="card-body">
                <table className="table table-hover">
                    <thead>
                        <th>Sl.</th>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Branch</th>
                    </thead>
                    <tbody>
                        {
                            userList && userList.length>0 && userList.map((users,index)=> 
                            <tr>
                                <td>{index+1}</td>
                                <td>{users.Username}</td>
                                <td>{users.Email}</td>
                                <td>{users.branchCode}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AddUser;
